import React, {useEffect} from 'react';
import {useCookies} from 'react-cookie';
import {AUTH_TOKEN, PERMISSIONS_KEY} from '../../../shared/constants/AppConst';
import {useDispatch, useSelector} from 'react-redux';
import {
  setAuthenticated,
  setInitialUrl,
  setMyPermissions,
} from 'src/domain/app/redux/auth/auth-slice';
import {authService} from 'src/shared/services/auth';
import MainUtils from 'src/shared/utils/main';
import routesConfig from 'src/pages/routeConfig';
import {getInitialUrl} from 'src/domain/app/redux/auth/auth-selectors';

const AuthProvider = (props: {children: React.ReactNode}) => {
  const [cookies] = useCookies([AUTH_TOKEN]);
  const dispatch = useDispatch();
  const pathName = useSelector(getInitialUrl);

  useEffect(() => {
    if (cookies[AUTH_TOKEN]) {
      dispatch(setAuthenticated(true));
      (async () => {
        try {
          await authService.getMyRoles().then((response) => {
            if (!MainUtils.isEmptyValue(response?.Data)) {
              let permissionsAll = response?.Data?.map((role) => {
                const permissionKeys = role?.permissions?.map((permission) => {
                  return permission.key;
                });
                return permissionKeys;
              }).reduce((acc: any, curr: any) => acc.concat(curr), []);
              dispatch(setMyPermissions(permissionsAll));
              localStorage.setItem(
                PERMISSIONS_KEY,
                JSON.stringify(permissionsAll),
              );

              let myPermissionsIsSidebar: any[] = [];
              routesConfig
                .filter(
                  (item: any) =>
                    permissionsAll.filter((permission: any) =>
                      item.permissionKey.includes(permission),
                    )?.length > 0,
                )
                .map((item: any) => {
                  if (item.children) {
                    const children = item.children.filter((child: any) =>
                      permissionsAll.includes(child.permissionKey),
                    );
                    if (children?.length > 0)
                      myPermissionsIsSidebar.push(...children);
                    return;
                  }
                  myPermissionsIsSidebar.push(item);
                  return;
                });

              if (
                myPermissionsIsSidebar &&
                myPermissionsIsSidebar?.length > 0
              ) {
                dispatch(
                  setInitialUrl(
                    myPermissionsIsSidebar.filter((item: any) => item.path)[0]
                      .path,
                  ),
                );
              }
            }
          });
        } catch (error) {
          console.error(error);
        }
      })();
    } else {
      dispatch(setAuthenticated(false));
      dispatch(setInitialUrl('/sign-in'));
    }
  }, [cookies[AUTH_TOKEN], routesConfig]);

  const Loader = () => (
    <div className='loader'>
      <div className='site-logo'>
        <img src='/assets/images/logo.png' alt='logo' />
      </div>
      <div className='loader-spin'>
        <span className='ant-spin-dot ant-spin-dot-spin'>
          <i></i>
          <i></i>
          <i></i>
          <i></i>
        </span>
      </div>
    </div>
  );
  return <>{pathName !== '/' ? props.children : <Loader />}</>;
};

export default AuthProvider;
